import { render, staticRenderFns } from "./AssetSummary.vue?vue&type=template&id=441090a4&"
import script from "./AssetSummary.vue?vue&type=script&lang=js&"
export * from "./AssetSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports